import React, { useState } from 'react';

import {
  DeviceSelectionStep,
  OAuthSignInStep,
  SignInStep,
  TermsAcceptanceStep,
} from './steps';

import { ModalProps, Steps, PartnerCloudUserAuthResponse } from 'types/types';
import { FIRST_ALERT_CONNECTED_ACCOUNTS } from 'config/flags';

const SignInModal = ({ account, oAuthData, closeModal }: ModalProps) => {
  // determine if oAuthData contains devices (typed check, no `any`)
  const hasDevices = Boolean(
    oAuthData && (oAuthData as Record<string, unknown>).devices
  );

  // Start at DeviceSelection when this is First Alert or when oAuthData provides devices.
  let initialStep: Steps;
  if (
    (FIRST_ALERT_CONNECTED_ACCOUNTS &&
      account?.partnerCloudName === 'First Alert') ||
    hasDevices
  ) {
    initialStep = Steps.DEVICE_SELECTION;
  } else if (!oAuthData) {
    initialStep = Steps.SIGN_IN;
  } else {
    initialStep = Steps.OAUTH_SIGN_IN;
  }

  const [userSession, setUserSession] =
    useState<PartnerCloudUserAuthResponse>();

  const [step, setStep] = useState<Steps>(initialStep);

  const steps = {
    [Steps.OAUTH_SIGN_IN]: OAuthSignInStep,
    [Steps.SIGN_IN]: SignInStep,
    [Steps.TERMS_ACCEPTANCE]: TermsAcceptanceStep,
    [Steps.DEVICE_SELECTION]: DeviceSelectionStep,
  };

  const Component = steps[step];

  const props = {
    account,
    oAuthData,
    userSession,
    closeModal,
    setUserSession,
    setStep,
  };

  return <Component {...props} />;
};

export default SignInModal;
